/* ============================================================================
   assets/ll-plush-hub.js
   Behaviour for sections/ll-plush-hub.liquid (Plushies & figurines).
   ============================================================================

   One asset serves every instance: roots are found by [data-llpz-root] and
   their id read from data-section-id.

   FILTERS ARE FACETED
     Type (tiles, pick several), who, size, budget, "Pick your design" and
     "Include sold out". Every chip is counted against the OTHER filters, so a
     chip only shows when pressing it would leave something on screen, and a
     combination never strands the shopper on an empty grid. The active chip
     always stays, so it can be undone.

   SHOW MORE
     Desktop and tablet show a set number of rows and a "Show N more" button.
     Any filter shows every match. Phones swipe one row instead.

   SOLD OUT
     Sold-out pieces sit behind "Include sold out". Their button is a restock
     alert: it saves the piece to the storefront's one watchlist, which the
     header watches for restocks.
============================================================================ */
(function () {
  if (window.__llPlushHubJS) return;
  window.__llPlushHubJS = true;

  var inited = {};
  var BELL = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a6 6 0 0 0-6 6v3.6l-1.7 3.1A1 1 0 0 0 5.2 16h13.6a1 1 0 0 0 .9-1.3L18 11.6V8a6 6 0 0 0-6-6Zm0 20a3 3 0 0 0 2.8-2H9.2A3 3 0 0 0 12 22Z"/></svg>';
  var BAG = '<svg class="llpz__ico-line" viewBox="0 0 24 24" aria-hidden="true"><path d="M5.5 8.5h13l-1.1 11a1.6 1.6 0 0 1-1.6 1.5H8.2a1.6 1.6 0 0 1-1.6-1.5l-1.1-11Z"/><path d="M9 10.5V7a3 3 0 0 1 6 0v3.5"/></svg>';

  function initInstance(ROOT_ID) {
    function boot(root) {
      if (!root || root.dataset.llpzReady === '1') return;
      root.dataset.llpzReady = '1';

      var cfg = {};
      try { cfg = JSON.parse(root.querySelector('[data-llpz-config]').textContent); } catch (e) { cfg = {}; }

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var phoneMQ = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
      var live = root.querySelector('[data-live]');
      var K_WATCH = 'll_watchlist';
      var cleanups = [];

      function $(sel) { return root.querySelector(sel); }
      function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
      function say(m) { if (live) live.textContent = m; }
      function readJSON(store, key, fb) {
        try { var v = store.getItem(key); return v ? JSON.parse(v) : fb; } catch (e) { return fb; }
      }
      function writeJSON(store, key, val) { try { store.setItem(key, JSON.stringify(val)); } catch (e) {} }
      function isArr(v) { return Object.prototype.toString.call(v) === '[object Array]'; }
      function rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
      function isPhone() { return !!(phoneMQ && phoneMQ.matches); }

      /* ---------------- toast ---------------- */
      var toast = $('[data-toast]');
      var toastText = $('[data-toast-text]');
      var toastLink = $('[data-toast-link]');
      var toastTimer = null;
      function showToast(msg, href, linkText) {
        if (!toast) return;
        toastText.textContent = msg;
        if (toastLink) {
          if (linkText === '') { toastLink.hidden = true; }
          else {
            toastLink.hidden = false;
            toastLink.href = href || cfg.cartUrl || '/cart';
            toastLink.textContent = linkText || 'View basket';
          }
        }
        toast.classList.add('is-on');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 4000);
        say(msg);
      }

      var grid = $('[data-grid]');
      var cards = $$('[data-grid] [data-card]');
      var types = $$('[data-type]');
      var charChips = $$('[data-char]');
      var sizeChips = $$('[data-size]');
      var priceChips = $$('[data-budget]');
      var designToggle = $('[data-design-toggle]');
      var soldToggle = $('[data-soldout-toggle]');
      var noRes = $('[data-no-results]');
      var sortSel = $('[data-sort]');
      var status = $('[data-status]');
      var statusText = $('[data-status-text]');
      var clearBtns = $$('[data-clear]');
      var moreRow = $('[data-more-row]');
      var moreBtn = $('[data-more]');
      var moreLabel = $('[data-more-label]');
      var tools = $('.llpz__tools');
      var filtersBtn = $('[data-filters-toggle]');
      var filtersN = $('[data-filters-n]');
      var doneBtn = $('[data-filters-done]');
      var doneLabel = $('[data-done-label]');

      var st = { cats: [], char: '', size: '', price: '', design: false, sold: false, expanded: false };

      function list(el, attr) { return (el.getAttribute(attr) || '').split(/\s+/).filter(Boolean); }
      cards.forEach(function (c) {
        c.__t = list(c, 'data-tokens');
        c.__k = list(c, 'data-chars');
        c.__band = c.getAttribute('data-band') || '';
        c.__pb = c.getAttribute('data-pband') || '';
        c.__design = c.getAttribute('data-design') === '1';
        c.__sold = c.getAttribute('data-soldout') === '1';
      });

      /* Does a card pass every filter except `skip`? */
      function passes(c, skip) {
        if (c.__sold && !st.sold) return false;
        if (skip !== 'cats' && st.cats.length) {
          var ok = false;
          for (var i = 0; i < st.cats.length; i++) { if (c.__t.indexOf(st.cats[i]) > -1) { ok = true; break; } }
          if (!ok) return false;
        }
        if (skip !== 'char' && st.char && c.__k.indexOf(st.char) === -1) return false;
        if (skip !== 'size' && st.size && c.__band !== st.size) return false;
        if (skip !== 'price' && st.price && c.__pb !== st.price) return false;
        if (skip !== 'design' && st.design && !c.__design) return false;
        return true;
      }
      function countFor(skip, test) {
        var n = 0;
        for (var i = 0; i < cards.length; i++) { if (passes(cards[i], skip) && test(cards[i])) n++; }
        return n;
      }
      function filtersOn() { return !!(st.cats.length || st.char || st.size || st.price || st.design); }
      function appliedCount() {
        return st.cats.length + (st.char ? 1 : 0) + (st.size ? 1 : 0) + (st.price ? 1 : 0) + (st.design ? 1 : 0) + (st.sold ? 1 : 0);
      }

      /* ---------------- faceted pruning ---------------- */
      function prune() {
        types.forEach(function (t) {
          var tok = t.getAttribute('data-token');
          var on = st.cats.indexOf(tok) > -1;
          var n = countFor('cats', function (c) { return c.__t.indexOf(tok) > -1; });
          t.hidden = !n && !on;
        });
        function chips(group, arr, key, get) {
          var any = false;
          arr.forEach(function (ch) {
            var val = ch.getAttribute(key);
            var on = st[group] === val;
            var n = countFor(group, function (c) { return get(c, val); });
            ch.hidden = !n && !on;
            if (!ch.hidden) any = true;
          });
          var g = root.querySelector('[data-group="' + group + '"]');
          if (g) g.hidden = !any || (group === 'char' && arr.filter(function (c) { return !c.hidden; }).length < 2 && !st.char);
        }
        chips('char', charChips, 'data-char', function (c, v) { return c.__k.indexOf(v) > -1; });
        chips('size', sizeChips, 'data-size', function (c, v) { return c.__band === v; });
        chips('price', priceChips, 'data-budget', function (c, v) { return c.__pb === v; });
        if (designToggle) {
          var nd = countFor('design', function (c) { return c.__design; });
          designToggle.hidden = !nd && !st.design;
        }
      }

      function paint() {
        types.forEach(function (t) { t.setAttribute('aria-pressed', st.cats.indexOf(t.getAttribute('data-token')) > -1 ? 'true' : 'false'); });
        charChips.forEach(function (c) { c.setAttribute('aria-pressed', st.char === c.getAttribute('data-char') ? 'true' : 'false'); });
        sizeChips.forEach(function (c) { c.setAttribute('aria-pressed', st.size === c.getAttribute('data-size') ? 'true' : 'false'); });
        priceChips.forEach(function (c) { c.setAttribute('aria-pressed', st.price === c.getAttribute('data-budget') ? 'true' : 'false'); });
        if (designToggle) designToggle.setAttribute('aria-pressed', st.design ? 'true' : 'false');
        if (soldToggle) soldToggle.setAttribute('aria-pressed', st.sold ? 'true' : 'false');
        var n = appliedCount();
        if (filtersN) { filtersN.textContent = n; filtersN.hidden = !n; }
        if (filtersBtn) filtersBtn.setAttribute('aria-label', n ? 'Filters, ' + n + ' applied' : 'Filters');
        clearBtns.forEach(function (b) { if (!b.closest('[data-no-results]') && !b.closest('[data-status]')) b.hidden = !n; });
      }

      /* ---------------- how many rows fit before "Show more" ---------------- */
      function limitNow() {
        if (isPhone() || !grid) return Infinity;
        var cols = 1;
        try {
          var tpl = getComputedStyle(grid).gridTemplateColumns;
          cols = tpl && tpl !== 'none' ? tpl.split(' ').filter(Boolean).length : 1;
        } catch (e) {}
        return Math.max(1, cols) * Math.max(1, cfg.rows || 2);
      }

      function apply() {
        if (grid) { if (st.sold) grid.setAttribute('data-sold-on', '1'); else grid.removeAttribute('data-sold-on'); }
        var shown = [];
        cards.forEach(function (c) {
          var ok = passes(c, null);
          c.hidden = !ok;
          c.classList.remove('is-over');
          if (ok) shown.push(c);
        });
        var cap = (filtersOn() || st.expanded) ? Infinity : limitNow();
        var over = 0;
        /* In DOM order, which is the sort order. */
        var inOrder = grid ? Array.prototype.slice.call(grid.children) : shown;
        var seen = 0;
        inOrder.forEach(function (c) {
          if (shown.indexOf(c) === -1) return;
          seen++;
          if (seen > cap) { c.classList.add('is-over'); over++; }
        });
        if (moreRow) moreRow.hidden = over === 0;
        if (moreLabel && over) moreLabel.textContent = 'Show ' + over + ' more';
        if (noRes) noRes.setAttribute('data-show', shown.length ? '0' : '1');
        if (status && statusText) {
          status.hidden = !filtersOn();
          statusText.textContent = shown.length + (shown.length === 1 ? ' piece matches' : ' pieces match');
        }
        if (doneLabel) doneLabel.textContent = shown.length ? 'Show ' + shown.length + (shown.length === 1 ? ' piece' : ' pieces') : 'Nothing matches';
        prune();
        paint();
        updateEdge();
        return shown.length;
      }

      function changed(msg) {
        st.expanded = false;
        var n = apply();
        if (grid) grid.scrollLeft = 0;
        say((msg ? msg + '. ' : '') + n + (n === 1 ? ' piece' : ' pieces') + ' shown');
      }

      types.forEach(function (t) {
        t.addEventListener('click', function () {
          var tok = t.getAttribute('data-token');
          var at = st.cats.indexOf(tok);
          if (at > -1) st.cats.splice(at, 1); else st.cats.push(tok);
          changed(t.textContent.trim() + (at > -1 ? ' off' : ' on'));
        });
      });
      function single(arr, key, group) {
        arr.forEach(function (ch) {
          ch.addEventListener('click', function () {
            var v = ch.getAttribute(key);
            st[group] = st[group] === v ? '' : v;
            changed(ch.textContent.replace(/\s+/g, ' ').trim());
          });
        });
      }
      single(charChips, 'data-char', 'char');
      single(sizeChips, 'data-size', 'size');
      single(priceChips, 'data-budget', 'price');
      if (designToggle) designToggle.addEventListener('click', function () { st.design = !st.design; changed('Pick your design ' + (st.design ? 'on' : 'off')); });
      if (soldToggle) soldToggle.addEventListener('click', function () { st.sold = !st.sold; sortNow(); changed('Sold out pieces ' + (st.sold ? 'shown' : 'hidden')); });

      function clearAll() {
        st.cats = []; st.char = ''; st.size = ''; st.price = ''; st.design = false; st.sold = false;
        changed('Filters cleared');
      }
      clearBtns.forEach(function (b) { b.addEventListener('click', clearAll); });

      if (moreBtn) moreBtn.addEventListener('click', function () {
        st.expanded = true;
        var first = grid && grid.querySelector('.is-over');
        apply();
        if (first) { var a = first.querySelector('a[href]'); if (a) try { a.focus({ preventScroll: true }); } catch (e) {} }
        say('Showing every piece');
      });

      /* ---------------- phone: the filter panel folds ---------------- */
      function setOpen(on) {
        if (!tools) return;
        tools.setAttribute('data-open', on ? '1' : '0');
        if (filtersBtn) filtersBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      }
      if (filtersBtn) filtersBtn.addEventListener('click', function () { setOpen(tools.getAttribute('data-open') !== '1'); });
      if (doneBtn) doneBtn.addEventListener('click', function () {
        setOpen(false);
        if (grid) try { grid.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' }); } catch (e) {}
      });
      setOpen(false);

      /* ---------------- sorting ---------------- */
      function num(el, attr) { var v = parseFloat(el.getAttribute(attr)); return isNaN(v) ? 0 : v; }
      function sortNow() {
        if (!grid || !sortSel) return;
        var mode = sortSel.value;
        var arr = cards.slice();
        arr.sort(function (a, b) {
          /* Sold-out pieces always follow the ones you can buy. */
          if (a.__sold !== b.__sold) return a.__sold ? 1 : -1;
          if (mode === 'price_asc') return num(a, 'data-price') - num(b, 'data-price');
          if (mode === 'price_desc') return num(b, 'data-price') - num(a, 'data-price');
          if (mode === 'size_asc' || mode === 'size_desc') {
            var ca = num(a, 'data-cm') || 99999, cb = num(b, 'data-cm') || 99999;
            if (ca === 99999 && cb === 99999) return num(a, 'data-pos') - num(b, 'data-pos');
            if (ca === 99999) return 1;
            if (cb === 99999) return -1;
            return mode === 'size_asc' ? ca - cb : cb - ca;
          }
          return num(a, 'data-pos') - num(b, 'data-pos');
        });
        arr.forEach(function (c) { grid.appendChild(c); });
      }
      if (sortSel) sortSel.addEventListener('change', function () { sortNow(); apply(); say('Sorted: ' + sortSel.options[sortSel.selectedIndex].text); });

      /* ---------------- phone rail edge fade ---------------- */
      function updateEdge() {
        if (!grid) return;
        if (!isPhone()) { grid.setAttribute('data-edge', 'none'); return; }
        var max = grid.scrollWidth - grid.clientWidth;
        if (max <= 4) { grid.setAttribute('data-edge', 'none'); return; }
        var x = grid.scrollLeft;
        grid.setAttribute('data-edge', x <= 2 ? 'right' : (x >= max - 2 ? 'left' : 'both'));
      }
      if (grid) grid.addEventListener('scroll', updateEdge, { passive: true });
      function onMQ() { st.expanded = st.expanded; apply(); }
      if (phoneMQ) {
        if (phoneMQ.addEventListener) phoneMQ.addEventListener('change', onMQ); else if (phoneMQ.addListener) phoneMQ.addListener(onMQ);
        cleanups.push(function () { if (phoneMQ.removeEventListener) phoneMQ.removeEventListener('change', onMQ); });
      }
      var rsz = null;
      function onResize() { clearTimeout(rsz); rsz = setTimeout(apply, 120); }
      window.addEventListener('resize', onResize);
      cleanups.push(function () { window.removeEventListener('resize', onResize); });

      /* =====================================================================
         WATCHLIST - one list for the storefront
      ===================================================================== */
      var watchChip = $('[data-watch-chip]');
      var watchCount = $('[data-watch-count]');
      var wv = $('[data-watch-view]');
      var wvGrid = $('[data-watch-grid]');
      var wvEmpty = $('[data-wv-empty]');
      var wvCount = $('[data-wv-count]');
      var wvClose = $('[data-wv-close]');
      var browseParts = [$('.llpz__types'), tools, status, grid, moreRow, noRes];

      function readWatch() {
        var l = readJSON(localStorage, K_WATCH, null);
        if (isArr(l)) return l;
        var old = readJSON(localStorage, 'll_preorder_watch', []);
        if (isArr(old) && old.length) { writeWatch(old); return old; }
        return [];
      }
      function writeWatch(l) {
        var clean = (l || []).slice(0, 100);
        writeJSON(localStorage, K_WATCH, clean);
        writeJSON(localStorage, 'll_preorder_watch', clean);
        var cid = root.getAttribute('data-customer-id');
        if (cid) writeJSON(localStorage, 'll_watchlist_c_' + cid, clean);
        try { document.dispatchEvent(new CustomEvent('ll:watchlist:change', { detail: { list: clean } })); } catch (e) {}
        return clean;
      }
      function unwatchHandle(handle) {
        var l = readWatch().filter(function (h) { return h !== handle; });
        writeWatch(l);
        try {
          var snaps = readJSON(localStorage, 'll_watchlist_snap', {});
          if (snaps && typeof snaps === 'object') { delete snaps[handle]; writeJSON(localStorage, 'll_watchlist_snap', snaps); }
        } catch (e) {}
        if (window.LLWatchlistLive && typeof window.LLWatchlistLive.stop === 'function') window.LLWatchlistLive.stop(handle);
        return l;
      }
      function paintWatch() {
        var l = readWatch();
        root.querySelectorAll('[data-card]').forEach(function (card) {
          var on = l.indexOf(card.getAttribute('data-handle')) > -1;
          var bell = card.querySelector('[data-watch]');
          if (bell) {
            bell.setAttribute('aria-pressed', on ? 'true' : 'false');
            var lab = bell.getAttribute(on ? 'data-watch-remove' : 'data-watch-add');
            if (lab) { bell.setAttribute('aria-label', lab); bell.setAttribute('title', lab); }
          }
          var cta = card.querySelector('[data-watch-cta]');
          if (cta) {
            cta.setAttribute('aria-pressed', on ? 'true' : 'false');
            var t = cta.querySelector('[data-cta-text]');
            var next = cta.getAttribute(on ? 'data-watch-remove' : 'data-watch-add');
            if (t && next) t.textContent = next;
          }
        });
        if (watchChip) {
          watchChip.hidden = l.length === 0;
          watchChip.setAttribute('data-has', l.length ? '1' : '0');
          if (watchCount) watchCount.textContent = l.length;
          if (!l.length) watchChip.setAttribute('aria-pressed', 'false');
        }
      }

      function toggleWatch(card, restock) {
        var handle = card.getAttribute('data-handle');
        var l = readWatch();
        if (l.indexOf(handle) > -1) {
          unwatchHandle(handle); paintWatch();
          if (wvOpen()) renderWatchView();
          showToast(cfg.watchRemoved || 'Removed from your watchlist', cfg.watchUrl || '/pages/watchlist', readWatch().length ? (cfg.watchLinkLabel || 'View watchlist') : '');
        } else {
          l.unshift(handle); writeWatch(l); paintWatch();
          if (window.LLWatchlistLive && typeof window.LLWatchlistLive.refresh === 'function') { try { window.LLWatchlistLive.refresh(); } catch (e) {} }
          showToast(restock ? (cfg.restockAdded || 'We will flag it on your watchlist when it is back') : (cfg.watchAdded || 'Saved to your watchlist'),
            cfg.watchUrl || '/pages/watchlist', cfg.watchLinkLabel || 'View watchlist');
        }
      }
      root.addEventListener('click', function (e) {
        var cta = e.target.closest('[data-watch-cta]');
        var bell = e.target.closest('[data-watch]');
        var el = cta || bell;
        if (!el || !root.contains(el)) return;
        e.preventDefault();
        e.stopPropagation();
        var card = el.closest('[data-card]');
        if (card) toggleWatch(card, !!cta || card.getAttribute('data-soldout') === '1');
      });

      function money(cents) {
        var v = (Number(cents) || 0) / 100;
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: cfg.currency || 'GBP' }).format(v);
        } catch (e) { return v.toFixed(2); }
      }
      function fetchProduct(handle) {
        var key = 'll_wv_' + handle;
        var hit = readJSON(sessionStorage, key, null);
        if (hit && hit.t && (Date.now() - hit.t) < 600000) return Promise.resolve(hit.p);
        return fetch(rootUrl() + 'products/' + handle + '.js')
          .then(function (r) { if (!r.ok) throw new Error('gone'); return r.json(); })
          .then(function (p) { writeJSON(sessionStorage, key, { t: Date.now(), p: p }); return p; });
      }
      function sized(src, w) {
        if (!src) return '';
        if (src.indexOf('//') === 0) src = 'https:' + src;
        return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
      }
      /* Same reading as the cards: the game prefix and "Choose Your Own" go,
         the maker stays as context. */
      function cleanName(t) {
        var n = String(t || '').replace(/：/g, ':');
        n = n.replace(/^Re-Ment\s+Pok[eé]mon\s*:\s*/i, '').replace(/^Pok[eé]mon\s*:\s*/i, '').replace(/^Pok[eé]mon\s+/i, '');
        n = n.replace(/\s*-\s*Choose Your Own\s*$/i, '').replace(/\s*\(?Japanese Import\)?/i, '');
        return n.replace(/ - /g, ' · ').trim() || t;
      }
      function wvCard(p) {
        var el = document.createElement('article');
        el.className = 'llpz__card';
        el.setAttribute('data-card', '');
        el.setAttribute('data-handle', p.handle);
        var url = rootUrl() + 'products/' + p.handle;
        el.setAttribute('data-url', url);
        el.setAttribute('data-title', p.title || '');
        var variant = null;
        for (var i = 0; i < (p.variants || []).length; i++) { if (p.variants[i].available) { variant = p.variants[i]; break; } }
        if (variant) el.setAttribute('data-vid', variant.id);
        var multi = (p.variants || []).length > 1;
        el.setAttribute('data-soldout', p.available ? '0' : '1');
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var cta;
        if (!p.available) {
          cta = '<a class="llpz__btn llpz__btn--ghost" href="' + url + '"><span class="llpz__btn-t">' + (cfg.soldOutLabel || 'Sold out') + '</span></a>';
        } else if (multi) {
          cta = '<a class="llpz__btn llpz__btn--ghost" href="' + url + '"><span class="llpz__btn-t">' + (cfg.optionsLabel || 'Choose') + '</span></a>';
        } else {
          cta = '<button type="button" class="llpz__btn" data-add>' + BAG + '<span class="llpz__btn-t">' + (cfg.addLabel || 'Add') + '</span></button>';
        }
        el.innerHTML =
          '<div class="llpz__pic">' +
            '<a class="llpz__media" href="' + url + '" tabindex="-1" aria-hidden="true">' +
              (img ? '<img src="' + sized(img, 420) + '" alt="" width="420" height="420" loading="lazy" decoding="async">' : '') +
              (!p.available ? '<span class="llpz__stock" data-s="off">Sold out</span>' : '') +
            '</a>' +
            '<button type="button" class="llpz__bell" data-watch aria-pressed="true">' + BELL + '</button>' +
          '</div>' +
          '<div class="llpz__body"><p class="llpz__kick"></p><h3 class="llpz__name"><a href="' + url + '"></a></h3></div>' +
          '<div class="llpz__foot"><p class="llpz__price">' + money(p.price) + '</p>' + cta + '</div>';
        el.querySelector('.llpz__kick').textContent = p.vendor || '';
        el.querySelector('.llpz__name a').textContent = cleanName(p.title) || p.handle;
        el.querySelector('.llpz__name a').setAttribute('title', p.title || '');
        var im = el.querySelector('img'); if (im) im.alt = p.title || '';
        var bell = el.querySelector('[data-watch]');
        bell.setAttribute('data-watch-add', 'Add ' + (p.title || 'this piece') + ' to your watchlist');
        bell.setAttribute('data-watch-remove', 'Remove ' + (p.title || 'this piece') + ' from your watchlist');
        bell.setAttribute('aria-label', bell.getAttribute('data-watch-remove'));
        return el;
      }
      function renderWatchView() {
        if (!wv || !wvGrid) return;
        var l = readWatch();
        if (wvCount) wvCount.textContent = l.length;
        wvGrid.innerHTML = '';
        if (!l.length) { if (wvEmpty) wvEmpty.setAttribute('data-show', '1'); return; }
        if (wvEmpty) wvEmpty.setAttribute('data-show', '0');
        wvGrid.innerHTML = '<p class="llpz__wv-skel">Loading your saved pieces…</p>';
        Promise.all(l.slice(0, 24).map(function (h) { return fetchProduct(h).catch(function () { return null; }); }))
          .then(function (items) {
            wvGrid.innerHTML = '';
            var gone = [], shown = 0;
            items.forEach(function (p, i) {
              if (!p) { gone.push(l[i]); return; }
              wvGrid.appendChild(wvCard(p)); shown++;
            });
            if (gone.length) {
              var kept = readWatch().filter(function (h) { return gone.indexOf(h) === -1; });
              writeWatch(kept); paintWatch();
              if (wvCount) wvCount.textContent = kept.length;
            }
            if (!shown && wvEmpty) wvEmpty.setAttribute('data-show', '1');
          });
      }
      function wvOpen() { return !!(wv && !wv.hidden); }
      function openWV() {
        if (!wv) return;
        wv.hidden = false;
        browseParts.forEach(function (el) { if (el) el.setAttribute('data-away', '1'); });
        if (watchChip) watchChip.setAttribute('aria-pressed', 'true');
        renderWatchView();
        say('Showing your watchlist');
      }
      function closeWV() {
        if (!wv) return;
        wv.hidden = true;
        browseParts.forEach(function (el) { if (el) el.removeAttribute('data-away'); });
        if (watchChip) watchChip.setAttribute('aria-pressed', 'false');
        apply();
        say('Back to browsing');
      }
      if (watchChip) watchChip.addEventListener('click', function () { wvOpen() ? closeWV() : openWV(); });
      if (wvClose) wvClose.addEventListener('click', closeWV);

      function syncWatchFromStore() {
        paintWatch();
        if (wvOpen()) { if (!readWatch().length) closeWV(); else renderWatchView(); }
      }
      function onStorage(ev) {
        if (!ev || !ev.key) return;
        if (ev.key === K_WATCH || ev.key === 'll_preorder_watch' || (ev.key.indexOf && ev.key.indexOf('ll_watchlist_c_') === 0)) syncWatchFromStore();
      }
      document.addEventListener('ll:watchlist:change', syncWatchFromStore);
      window.addEventListener('storage', onStorage);

      /* ---------------- quick add ---------------- */
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-add]');
        if (!btn || !root.contains(btn)) return;
        e.preventDefault();
        var card = btn.closest('[data-card]');
        var id = card && card.getAttribute('data-vid');
        if (!id) { if (card) window.location.href = card.getAttribute('data-url'); return; }
        if (btn.classList.contains('is-busy')) return;
        btn.classList.add('is-busy');
        fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add');
            btn.classList.add('is-done');
            setTimeout(function () { btn.classList.remove('is-done'); }, 1600);
            showToast(cfg.added || 'Added to your basket', cfg.cartUrl, 'View basket');
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          })
          .catch(function (err) { showToast(err.message || 'Sorry, that could not be added', card.getAttribute('data-url'), 'View item'); })
          .then(function () { btn.classList.remove('is-busy'); });
      });

      /* Everything sold out: show the sold-out pieces rather than an empty
         grid, so the restock alerts are the first thing on offer. */
      if (cards.length && !cards.some(function (c) { return !c.__sold; })) st.sold = true;

      sortNow();
      apply();
      paintWatch();

      root.llpzDestroy = function () {
        cleanups.forEach(function (f) { try { f(); } catch (e) {} });
        document.removeEventListener('ll:watchlist:change', syncWatchFromStore);
        window.removeEventListener('storage', onStorage);
        clearTimeout(toastTimer);
        root.dataset.llpzReady = '';
      };
    }

    function find() { return document.querySelector('[data-llpz-root][data-section-id="' + ROOT_ID + '"]'); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(find()); });
    else boot(find());
    document.addEventListener('shopify:section:load', function (e) {
      if (String(e.detail.sectionId) !== ROOT_ID) return;
      boot(find());
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (String(e.detail.sectionId) !== ROOT_ID) return;
      var el = find();
      if (el && el.llpzDestroy) el.llpzDestroy();
    });
  }

  function initOnce(id) {
    if (!id || inited[id]) return;
    inited[id] = true;
    initInstance(id);
  }
  function bootAll() {
    var roots = document.querySelectorAll('[data-llpz-root][data-section-id]');
    for (var i = 0; i < roots.length; i++) initOnce(roots[i].getAttribute('data-section-id'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e && e.detail && String(e.detail.sectionId);
    if (id) delete inited[id];
  });
})();
